<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      background-color="#21242d"
      text-color="#f9f9f9"
      active-text-color="#20a0ff"
      unique-opened
      router
      @select="charge"
    >
		<div class="logo">乾保网</div>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template #title>
              <i :class="item.icon" style="color: #006cd8"></i>
              <span>{{ item.title }}</span>
            </template>
              <el-menu-item  v-for="subItem in item.subs" :index="subItem.index" :key="subItem.index"
                >{{ subItem.title }}
              </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon" style="color: #006cd8"></i>
            <template #title>{{ item.title }}</template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
		<div class="info">
        <img style="width: 100PX" src="../assets/login/code.png" alt="" />
        <p style="margin:20PX 0;">官方客服微信</p>
				<P><a style="color: #ffffff; text-decoration: none;" href="https://beian.miit.gov.cn/" target="_blank">ICP备:鄂ICP备16015336号-5</a></P>
				<P>公安备案号:11010502048927</P>
				<P>河北省石家庄市新华区中华北大街27号鑫明商务中心211</P>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "el-icon-document",
          index: "1",
          title: "保函申请",
          subs: [
            {
              index: "/selfHelp",
              title: "投标保证保险",
            },
            {
              index: "/advancePayment",
              title: "预付款保证保险",
            },
            {
              index: "/performance",
              title: "履约保证保险",
            },
            {
              index: "/wages",
              title: "农民工工资保证保险",
            },
          ],
        },
        {
          icon: "el-icon-printer",
          index: "2",
          title: "订单管理",
          subs: [
            {
              index: "/order",
              title: "订单历史",
            },
            {
              index: "/surrender",
              title: "退保管理",
            },
          ],
        },
        {
          icon: "el-icon-s-cooperation",
          index: "3",
          title: "发票管理",
          subs: [
            {
              index: "/administration",
              title: "申请发票",
            },
            {
              index: "/invoice",
              title: "发票明细",
            },
            // {
            //   index: "/management",
            //   title: "开票信息管理",
            // },
          ],
        },
        {
          icon: "el-icon-user-solid",
          index: "/personalInfo",
          title: "账号中心",
        },
      ],
    };
  },
  computed: {
    // onRoutes() {
    //   return this.$route.path;
    // },
    onRoutes() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
  },
  methods: {
    charge(key, keyPath) {
      if (key == '/selfHelp') {
        this.$router.push({name:'selfHepl'})
      }
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.logo {
  font-family: none;
  padding: 10PX 0;
  font-size: 30PX;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  letter-spacing: 5PX;
}
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
	font-size: 11PX;
	padding: 30PX;
	// margin-top: 120PX;
  p{
		text-align: center;
		line-height: 26PX;
	}
}
.sidebar {
  display: block;
  position: absolute;
	width: 250PX;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  background-color: #21242d;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250PX;
}

.sidebar > ul {
  // height: 100%;
}
.el-menu {
  border: 0PX;
}
/* .is-active{
	border-left: red solid 5PX;
} */
 ::v-deep .el-submenu.is-active .el-submenu__title{
	border-left:solid 3PX #3B7DF9 !important;
} 
::v-deep .el-menu-item.is-active{
  border-left:solid 3PX #3B7DF9 !important;
}
/* ::v-deep .el-menu-item.is-active{
	border-left:solid 3PX red !important;
} */
</style>
